import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const coachingNoteCategoriesState = (state: RootState) => state.scene.dashboard.coaching.categories;

export const getCoachingNoteCategories = createSelector(
  coachingNoteCategoriesState,
  ({ categories }) => categories
);

export const isCoachingNoteCategoriesLoading = createSelector(
  coachingNoteCategoriesState,
  ({ loading }) => loading
);
